import { render } from "./sectionh.vue?vue&type=template&id=f659eb8a"
import script from "./sectionh.vue?vue&type=script&lang=js"
export * from "./sectionh.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__